import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import AuthProvider from './hooks/provider'
import './i18n/config' // Initialize i18n
import './styles/global.css'
import './styles/blog.css'
import './styles/codeblock.css'

// Loading fallback for i18n lazy loading
// Note: This component renders before i18n is fully initialized, so we use a simple
// CSS-based approach to show localized text without requiring the useTranslation hook.
// The loading text is minimal and universal enough that a simple "Loading..." works.
const I18nLoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-primary">
    <div className="flex flex-col items-center gap-3">
      <div className="w-8 h-8 border-2 border-accent border-t-transparent rounded-full animate-spin" />
      <span className="text-secondary text-sm" aria-label="Loading">Loading...</span>
    </div>
  </div>
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <Suspense fallback={<I18nLoadingFallback />}>
            <App />
          </Suspense>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
)